export default {"src":"/_next/static/media/404-dark.d492d577.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};